import { Component, Input, OnInit } from '@angular/core';
import { IonCheckbox } from '@ionic/angular/standalone';
import { SubscriptionPreferences } from 'src/class/classes';
import { FirestoreService } from 'src/services/firestore.service';
import { GlobalsService } from 'src/services/globals.service';
import { BankAccount } from 'bankapp-types';

@Component({
    selector: 'app-subscribe',
    templateUrl: './subscribe.component.html',
    styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {

    @Input() bankAccounts: Array<BankAccount>

    events = new SubscriptionPreferences()


    constructor(
        private firestoreService: FirestoreService,
        private globalsService: GlobalsService
    ) { }

    ngOnInit() {
        console.log(this.bankAccounts)
        if (this.bankAccounts && this.bankAccounts.length === 1 && this.bankAccounts[0].subscriptions?.[this.globalsService.authSubject.value?.uid]) {
            for (let [key, val] of Object.entries(this.bankAccounts[0].subscriptions[this.globalsService.authSubject.value?.uid])) {
                this.events[key].checked = val
            }
        }
    }


    submitSubscriptions() {
        this.firestoreService.saveSubscriptionPrefs(this.events, this.bankAccounts)
    }

}
